export const centerChildStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center'
};
